<template>
<div>
    <mdb-streak md :quote="quote" :by="by" byClass="grey-text font-weight-bold" quoteClass="font-weight-bold" wrapperClass="white" />
    <hr class="mb-5" />
</div>
</template>

<script>
import { mdbStreak } from 'mdbvue';

export default {
  name: 'StreakExample',
  components: {
    mdbStreak
  },
  data() {
    return {
      quote: 'Lo difícil lo hacemos ahora, lo imposible nos toma unos minutos más',
      by: 'ILA'
    };
  }
}
</script>
